import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { OfflineInvoiceForm } from './OfflineInvoiceForm'
import { draftInvoiceService, DraftInvoice } from '../services/draftInvoiceService'
import { toast } from 'sonner'

const OfflineInvoiceCreatePage: React.FC = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id?: string }>()
  const [invoice, setInvoice] = useState<DraftInvoice | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (id) {
      loadInvoice(parseInt(id))
    }
  }, [id])

  const loadInvoice = async (invoiceId: number) => {
    setIsLoading(true)
    try {
      const data = await draftInvoiceService.getDraftInvoice(invoiceId)
      if (data) {
        setInvoice(data)
      } else {
        toast.error('Draft invoice not found')
        navigate('/offline-invoices')
      }
    } catch (error) {
      console.error('Error loading invoice:', error)
      toast.error('Failed to load draft invoice')
      navigate('/offline-invoices')
    } finally {
      setIsLoading(false)
    }
  }

  const handleSuccess = () => {
    navigate('/offline-invoices')
  }

  if (isLoading) {
    return <div className="container mx-auto py-6">Loading...</div>
  }

  return (
    <div className="container mx-auto py-6">
      <OfflineInvoiceForm initialData={invoice || undefined} onSuccess={handleSuccess} />
    </div>
  )
}

export default OfflineInvoiceCreatePage
